import React, { useEffect, useState } from 'react';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { AddAlert, ExpandMore } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import Searchicon from '../../../../assets/images/Search.svg';
import {
  TextField,
  Button,
  Select,
  IconButton,
  FormGroup,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Chip,
  Typography,
  FormHelperText,
} from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import {
  Remove as MinusIcon,
  ArrowDropDown,
  ArrowDropUp,
} from '@mui/icons-material';
import { useHook as ControllerHook } from '../controllerPage/useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
import { useHook as EquipmentHook } from './useHook';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { closeIcon } from '../../../../assets/images/index';
import { setGetControllerDetails } from '../../../../stores/actionTypes/controllerActions';
import { UrlToBase } from '../../../../components/urlToBase64';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import {
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error"; // for "danger"
import CreateAlert from './createAlert';



const EquipmentsAlertsEdit = (props: any) => {
  const { editData, formSubmit,setEquipmentsPage,setEquipmentsPayload,equipmentsPayload } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { controllerAllList, controllerDetails } = useSelector(
    (state: any) => state.controller,
  );
  const statusOptions = [
  { value: "info", label: "Info", icon: <InfoIcon color="info" /> },
  { value: "warning", label: "Warning", icon: <WarningIcon color="warning" /> },
  { value: "danger", label: "Danger", icon: <ErrorIcon color="error" /> },
];
const notificationOptions:any = ["push", "db", "email"];
  const [filteredControllerData, setFilteredControllerData] =
    useState<any>(controllerAllList);
  const [selectedControllerData, setSelectedControllerData] =
    useState<string>('');
  const { fetchAllControllerList, fetchGetControllerDetails } =
    ControllerHook();
  const { fetchGetAllRoleList } = RoleHook();
  const { createEquipment, editEquipment } = EquipmentHook();
 const [formData, setFormData] = useState<any>({
  eventType: editData ? editData?.eventType : "",
  values: editData
    ? editData?.values
    : [
        {
          value: "",
          title: "",
          desc: "",
          icon: "",
          channels: [],
        },
      ],
});


  const [controllerParameter, setControllerParameter] = useState<any>([]);
  const [expanded, setExpanded] = useState<number[]>([]);
  const [expandedForm, setExpandedForm] = useState<number[]>([]);
  const { allRole } = useSelector((state: any) => state.role);
  const [tagName, setTagName] = React.useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState<string[]>([]);
  const [isActiveParam, setIsActiveParam] = useState(false);
  const [isActiveSubmitParam, setIsActiveSubmitParam] = useState(false);
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [isActive, setIsActive] = useState(false);
    const [openCategory, setOpenCategory] = useState(false);
    const [selectedCategory,setSelectedCategory] = useState("")
     const [selectedNotifications, setSelectedNotifications] = useState<any>([]);
const [alerts,setAlerts] = useState<any>([])
  const handleNotificationsChange = (event:any) => {
    const {
      target: { value },
    } = event;
    setSelectedNotifications(typeof value === "string" ? value.split(",") : value);
  };


      const handleCloseCategory = () => {
    setOpenCategory(false);
  };
    const handleActiveChange = () => {
    setIsActive(true);
  };
  const [validationErrors, setValidationErrors] = useState<
 any
  >({});
  const [cotrollerOpen, setCotrollerOpen] = useState(false);
  const [activeEditedData, setActiveEditedData] = useState<number[]>([]);

  const handleCloseCotroller = () => {
    setCotrollerOpen(false);
    setFilteredControllerData(controllerAllList);
  };

  const getControllerList = async () => {
    await fetchAllControllerList({});
  };
  useEffect(() => {
    if (!(controllerAllList?.length > 0)) {
      getControllerList();
    }
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
    dispatch(setGetControllerDetails({}));
  }, []);

  useEffect(() => {
    setFilteredControllerData(controllerAllList);
  }, [controllerAllList]);

  useEffect(() => {
    if (editData) {
      setSelectedControllerData(editData?.controller?.controllerID);
      const addmissingValue = editData?.controller?.parameters?.map(
        (obj: any) => {
          return {
            order: obj?.order ? obj?.order : 0,
            decimals: obj?.decimals ? obj?.decimals : 2,
            minValue: obj?.minValue ? obj?.minValue : '0',
            maxValue: obj?.maxValue ? obj?.maxValue : '0',
            defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
            primary: obj?.controllerVariable
              ? obj?.controllerVariable === editData?.primaryParameter
              : false,
            ...obj,
          };
        },
      );
      setControllerParameter(addmissingValue);
    }
  }, [editData]);

  useEffect(() => {
    const paramData = {
      unit: 'A',
      decimals: 2,
      minValue: '0',
      maxValue: '0',
      defaultValue: 0,
      order: 0,
    };

    if (controllerDetails?.parameters) {
      const addedParamData = controllerDetails?.parameters?.map((obj: any) => {
        return {
          controllerVariable: obj?.variableName,
          parameterName: obj?.name,
          parameterComment: obj?.comment,
          accessPermissions: obj?.accessPermissions,
          customerAccess: obj?.customerAccess,
          behaviour: obj?.behaviour,
          ...paramData, // Spread the paramData values to add
        };
      });
      setControllerParameter(addedParamData);
    } else {
      if (editData) {
        const addmissingValue = editData?.controller?.parameters?.map(
          (obj: any) => {
            return {
              order: obj?.order ? obj?.order : 0,
              decimals: obj?.decimals ? obj?.decimals : 2,
              minValue: obj?.minValue ? obj?.minValue : '0',
              maxValue: obj?.maxValue ? obj?.maxValue : '0',
              defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
              primary: obj?.controllerVariable
                ? obj?.controllerVariable === editData?.primaryParameter
                : false,
              ...obj,
            };
          },
        );
        setControllerParameter(addmissingValue);
      }
    }
  }, [controllerDetails]);

  useEffect(() => {
    setFilteredRoles(allRole);
  }, [allRole]);

  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: any) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };

  const handleControllSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: any = controllerAllList?.filter((user: any) =>
      user?.controllerName?.toLowerCase().includes(query),
    );

    setFilteredControllerData(filtered);
  };

  const handleChangeTagName = (event: any) => {
    const {
      target: { value },
    } = event;
    setTagName(typeof value === 'string' ? value.split(',') : value);
    setIsActiveParam(true);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = allRole?.filter((role: { roleName: string }) =>
      role.roleName?.toLowerCase().includes(query),
    );
    setFilteredRoles(filtered);
  };

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedRole((prevselectedRole) => {
      if (prevselectedRole.includes(roleName)) {
        const updatedRoles = prevselectedRole.filter(
          (roles) => roles !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevselectedRole, roleName];
        return updatedRoles;
      }
    });
    handleremoveError('role');
    setSeeMoreIndex(2);
  };

  const handleControllDisplay = async (controllerID: any) => {
    if (controllerID) {
      setSelectedControllerData(controllerID);
      if (editData && editData?.controller?.controllerID === controllerID) {
        setControllerParameter(editData?.controller?.parameters);
      } else {
        await fetchGetControllerDetails({ controllerID });
      }
    } else {
      setSelectedControllerData('');
    }
    setExpandedForm([]);
    setExpanded([]);
    setValidationErrors({});
    setIsActiveParam(false);
    setIsActiveSubmitParam(true);
  };

const validateForm = () => {

  const errors: any = {};

  // ✅ Validate eventType
  if (!formData.eventType || formData.eventType.trim() === "") {
    errors.eventType = "Event Type is required";
  }

  // ✅ Validate each value object
  errors.values = formData.values.map((val: any, index: number) => {
    const valueErrors: any = {};

    if (!val.title || val.title.trim() === "") {
      valueErrors.title = "Title is required";
    }
    if (!val.desc || val.desc.trim() === "") {
      valueErrors.desc = "Description is required";
    }
    if (!val.icon || val.icon.trim() === "") {
      valueErrors.icon = "Icon is required";
    }
    if (!val.channels || val.channels.length === 0) {
      valueErrors.channels = "At least one channel is required";
    }

    return valueErrors;
  });

  // Check if any valueErrors are non-empty
  const hasValueErrors = errors.values.some(
    (valErrors: any) => Object.keys(valErrors).length > 0
  );


  setValidationErrors(errors);
  return !errors.eventType && !hasValueErrors;
};



  const handleremoveError = (name: string) => {
    if (!name) return;
    // const updateError = { ...validationErrors };
    // delete updateError[name];
    // setValidationErrors(updateError);

    // Create a copy of the current validation errors
    setValidationErrors((prevErrors:any) => {
      // Use a new object to avoid mutating the previous state directly
      const { [name]: _, ...updatedErrors } = prevErrors;
      return updatedErrors;
    });
  };




  const toggleExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      if (expanded?.includes(index)) {
        const removedExpand = expanded.filter((item: number) => item !== index);
        setExpanded(removedExpand);
      } else {
        setExpanded([...expanded, index]);
      }
    }
    setValidationErrors({});
    setIsActiveParam(false);
  };

  const toggleFormExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      setExpandedForm([index]);
    }
    const removedExpand = expanded.filter((item: number) => item !== index);
    setExpanded(removedExpand);
    setValidationErrors({});
    setIsActiveParam(false);
  };

  useEffect(() => {
    if (editData) {
      const imageUrl = editData?.image;
      if (imageUrl) {
        UrlToBase(imageUrl)
          .then((base64String) => {
            setCroppedImages(base64String);
          })
          .catch((error) => console.error(error));
      }
    }
  }, [editData]);

  const [editIndex, setEditIndex] = useState<number | null>(null);
const handleAddAlert = async (data: any) => {
//    if (!validateForm()) {
//     return; // stop if errors
//   }

  setIsActiveSubmitParam(false);

  const newAlert = {
    eventType: data.eventType,
    values: data.values,
  };

  if (editIndex !== null) {
    // ✅ update existing alert
    setAlerts((prev: any[]) =>
      prev.map((alert, i) => (i === editIndex ? newAlert : alert))
    );
    setEditIndex(null); // reset edit mode
  } else {
    // ✅ add new alert
    setAlerts((prev: any[]) => [...prev, newAlert]);
  }

  // reset form
  reset({
    eventType: "",
    values: [{ value: "", title: "", desc: "", icon: "", channels: [] }],
  });

  setActiveEditedData([]);
};

    const {
      register,
      handleSubmit,
      control,
      reset,
      formState: { errors },
    }:any = useForm({
      defaultValues: formData,
    });

const { fields, append, remove } = useFieldArray({
  control,
  name: "values", // this tells RHF to manage the `values[]` array
});

  return (
    <>
       
   

        <CreateAlert
  formData={formData}
  setFormData={setFormData}
  formSubmit={formSubmit}
  alerts={alerts}
  reset={reset}
  setAlerts={setAlerts}
  editIndex={editIndex}
  setEditIndex={setEditIndex}
  statusOptions={statusOptions}
      handleSubmit={handleSubmit}
  handleAddAlert={handleAddAlert}
  register={register}
  errors={errors}
  editData={editData}
  validationErrors={validationErrors}
  handleActiveChange={handleActiveChange}
  handleremoveError={handleremoveError}
  fields={fields}
  control={control}
  remove={remove}
append={append}
isActive={isActive}
setActiveEditedData={setActiveEditedData}
activeEditedData={activeEditedData}
edit={false}
  />
  


    </>
  );
};
const MemoizedComponent = React.memo(EquipmentsAlertsEdit);
export default MemoizedComponent;



//not showing errors, didsabled buttons --
//cursor pointer in heading ---
//remove disable if first value 
